import { Link } from 'react-router-dom';

export default function BlogPromo() {
  return (
    <section className="py-16 bg-gradient-to-r from-slate-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* 左侧图片 */}
            <div className="lg:w-2/5 relative">
              <img
                src="https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/fc0dc12eff12521a89283b60ef11764d.jpeg"
                alt="Adobe PDF Converter SDK"
                className="w-full h-64 lg:h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/20 lg:bg-gradient-to-l"></div>
            </div>
            
            {/* 右侧内容 */}
            <div className="lg:w-3/5 p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-4">
                <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">
                  产品指南
                </span>
                <span className="text-gray-400 text-sm">推荐阅读</span>
              </div>
              
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                何时选用 Adobe PDF Converter SDK
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                对于有高吞吐量、高精度 PDF 生成需求的企业组织而言，Adobe PDF Converter SDK 提供了一款专为 OEM 工作流打造的高性能、可定制化引擎。了解它如何帮助您实现 PDF 创建流程的自动化、集成化与精细化管控。
              </p>
              
              <div className="flex flex-wrap gap-3 mb-8">
                <span className="flex items-center gap-1 text-sm text-gray-500">
                  <i className="ri-checkbox-circle-line text-teal-500"></i>
                  高吞吐量自动化
                </span>
                <span className="flex items-center gap-1 text-sm text-gray-500">
                  <i className="ri-checkbox-circle-line text-teal-500"></i>
                  多格式兼容
                </span>
                <span className="flex items-center gap-1 text-sm text-gray-500">
                  <i className="ri-checkbox-circle-line text-teal-500"></i>
                  并行处理
                </span>
                <span className="flex items-center gap-1 text-sm text-gray-500">
                  <i className="ri-checkbox-circle-line text-teal-500"></i>
                  灵活集成
                </span>
              </div>
              
              <Link
                to="/blog-pdf-converter-sdk"
                className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-medium transition-colors w-fit cursor-pointer whitespace-nowrap"
              >
                阅读完整文章
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
